import { type JSX } from 'react';
import HorizontalBanner, {
  Subtitle,
  TextsContainer,
  Button,
} from '@monofront/design-system/components/HorizontalBanner';
import Add from '@monofront/design-system/visuals/Icons/Add';
import { useDisplayOrderDetailEntrypoint } from '@monofront/lateaddtocart-shared';

export type LateAddToCartBannerProps = {
  orderId: string;
  title: string;
  subtitle?: string;
  buttonLabel?: string;
  onPress: () => void;
};

const Title = ({ children }: { children: string }) => (
  <span className="tw-self-start tw-text-sm tw-font-bold">{children}</span>
);

export const LateAddToCartBanner = ({
  orderId,
  title,
  subtitle,
  buttonLabel,
  onPress,
}: LateAddToCartBannerProps): JSX.Element | null => {
  const { displayEntrypoint, loading } =
    useDisplayOrderDetailEntrypoint(orderId);

  if (loading || !displayEntrypoint) {
    return null;
  }

  return (
    <HorizontalBanner onClick={onPress} attributeTitle={title}>
      <TextsContainer>
        <Title>{title}</Title>
        {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
      </TextsContainer>
      <Button onClick={onPress} icon={<Add />}>
        {buttonLabel}
      </Button>
    </HorizontalBanner>
  );
};
